import type {
  CapacityImportConfirmPayload,
  CapacityImportConfirmResult,
  CapacityImportRecordDetail,
  CapacityImportRecordSummary,
  CapacityPlanParseResult,
} from '@/types/capacityImport';
import apiClient from './axios';

export async function parseCapacityPlan(file: File): Promise<CapacityPlanParseResult> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await apiClient.post<CapacityPlanParseResult>('/capacity-import/parse', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    skipGlobalError: true,
  });
  return data;
}

export async function confirmCapacityImport(payload: CapacityImportConfirmPayload): Promise<CapacityImportConfirmResult> {
  const { data } = await apiClient.post<CapacityImportConfirmResult>('/capacity-import/confirm', payload, {
    skipGlobalError: true,
  });
  return data;
}

export async function fetchImportRecords(): Promise<CapacityImportRecordSummary[]> {
  const { data } = await apiClient.get<CapacityImportRecordSummary[]>('/capacity-import/records', {
    skipGlobalError: true,
  });
  return data;
}

export async function fetchImportRecord(id: string): Promise<CapacityImportRecordDetail> {
  const { data } = await apiClient.get<CapacityImportRecordDetail>(`/capacity-import/records/${id}`, {
    skipGlobalError: true,
  });
  return data;
}

export async function deleteImportRecord(id: string): Promise<void> {
  await apiClient.delete(`/capacity-import/records/${id}`, { skipGlobalError: true });
}
